if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: [".product__media-item"],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        // Store original media items IMMEDIATELY before any modifications
        // Only store if not already stored (prevent overwriting with filtered set)
        if (!this.originalMediaItems || this.originalMediaItems.length === 0) {
          const allMediaItems = [
            ...this.querySelectorAll(".product__media-item"),
          ];
          this.originalMediaItems = allMediaItems.map((item) =>
            item.cloneNode(true)
          );
          //           console.log(
          //             "💾 EARLY Stored",
          //             this.originalMediaItems.length,
          //             "original media items (as clones)"
          //           );

          // Debug: Show first few media alt texts (images and videos)
          const sampleAlts = this.originalMediaItems.slice(0, 5).map((item) => {
            const img = item.querySelector("img");
            const videoElement =
              item.querySelector("video-element") ||
              item.querySelector("video");
            // Check inside video-element first for YouTube/Vimeo iframes
            const iframe =
              videoElement?.querySelector("iframe") ||
              item.querySelector("iframe");
            const mediaType = item.dataset.mediaType || "unknown";

            const alt =
              img?.alt ||
              videoElement?.dataset?.alt ||
              videoElement?.getAttribute("alt") ||
              iframe?.title ||
              iframe?.getAttribute("title") ||
              item.dataset.alt ||
              "no-alt";

            return `${alt} [${mediaType}]`;
          });
          //           console.log("📋 Sample media alts:", sampleAlts);

          // Also store original thumbnails
          const thumbWrapper = this.querySelector('[id^="Slider-Thumbnails"]');
          if (thumbWrapper) {
            const allThumbs = [
              ...thumbWrapper.querySelectorAll(".product__thumbs-item"),
            ];
            this.originalThumbnails = allThumbs.map((thumb) =>
              thumb.cloneNode(true)
            );
            //             console.log(
            //               "💾 Stored",
            //               this.originalThumbnails.length,
            //               "original thumbnails"
            //             );
          }
        } else {
          //           console.log(
          //             "ℹ️ Original media items already stored:",
          //             this.originalMediaItems.length
          //           );
        }

        this.init();
      }

      init() {
        //         console.log("🎬 Media Gallery: Initializing...");

        this.elements = window.FoxTheme.utils.queryDomNodes(
          this.selectors,
          this
        );
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === "true";
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === "true";
        this.enableMobileThumbnails =
          this.dataset.enableMobileThumbnails === "true";
        this.enableImageZoom = this.dataset.enableImageZoom === "true";
        this.context = this.dataset.context;

        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          this.initImageZoom();
        }

        //         console.log("✅ Media Gallery: Initialized successfully");
      }

      ensureImagesVisible() {
        // Make sure all images (except swatches) are visible on load
        const allMedia = this.querySelectorAll(".product__media-item");
        allMedia.forEach((media) => {
          const img = media.querySelector("img");
          const alt = img?.alt || "";
          if (!alt.toUpperCase().includes("_SWATCH")) {
            media.style.display = "";
            media.style.order = "";
          }
        });
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);
        const mediaItemGapMobile = parseInt(this.dataset.mediaItemGapMobile);

        this.sliderOptions = {
          init: false,
          slidesPerView: this.enableMobileThumbnails ? 1 : "auto",
          spaceBetween: mediaItemGapMobile,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          breakpoints: {
            768: {
              spaceBetween: mediaItemGap,
            },
          },
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            type: "fraction",
          },
          threshold: 10,
          touchStartPreventDefault: false,
          touchStartForcePreventDefault: false,
          passiveListeners: true,
          touchEventsTarget: "wrapper",
          preventInteractionOnTransition: false,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
              direction: "horizontal",
            },
          },
          spaceBetween: mediaItemGapMobile,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
          breakpoints: {
            768: {
              spaceBetween: mediaItemGap,
            },
          },
        };

        switch (this.mediaLayout) {
          case "vertical-carousel":
            this.thumbsOptions.breakpoints = {
              ...this.thumbsOptions.breakpoints,
              768: {
                direction: "vertical",
                slidesPerView: "auto",
                spaceBetween: mediaItemGap,
              },
            };
            break;
          case "carousel":
            this.thumbsOptions.breakpoints = {
              ...this.thumbsOptions.breakpoints,
              1024: {
                slidesPerView: 5,
              },
              1536: {
                slidesPerView: 7,
              },
            };
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== "object") {
          if (
            (this.enableDesktopSlider || this.enableMobileThumbnails) &&
            this.elements.thumbnails
          ) {
            this.thumbsInstance = new window.FoxTheme.Carousel(
              this.elements.thumbnails,
              this.thumbsOptions
            );
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(
            this.elements.viewer,
            this.sliderOptions,
            [FoxTheme.Swiper.Thumbs]
          );
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === "object") {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== "object") {
          this.thumbsInstance = new window.FoxTheme.Carousel(
            this.selectors.thumbnails,
            this.thumbsOptions
          );
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [
          ...this.querySelectorAll(
            ".product__media-item:not(.swiper-slide-duplicate)"
          ),
        ];

        //         console.log(
        //           "🔍 Initializing image zoom with",
        //           allMedia.length,
        //           "images"
        //         );

        // Debug: show sample images for zoom
        if (allMedia.length > 0 && allMedia.length <= 15) {
          const sampleAlts = allMedia.slice(0, 3).map((m) => {
            const img = m.querySelector("img");
            return img?.alt || "no-alt";
          });
          //           console.log("  📋 Sample zoom images:", sampleAlts);
        }

        if (allMedia) {
          allMedia.forEach((media, index) => {
            switch (media.dataset.mediaType) {
              case "model":
                dataSource.push({
                  id: index, // Use sequential index instead of original mediaIndex
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector("product-model").outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case "video":
              case "external_video":
                dataSource.push({
                  id: index, // Use sequential index instead of original mediaIndex
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector("video-element").outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case "image":
                dataSource.push({
                  id: index, // Use sequential index instead of original mediaIndex
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter("thumbEl", (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector("img");
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter(
          "placeholderSrc",
          (placeholderSrc, { data: { id } }) => {
            if (this.sliderInstance && this.sliderInstance.slider) {
              const { slides, activeIndex } = this.sliderInstance.slider;
              if (slides[activeIndex]) {
                const el = slides[activeIndex].querySelector("img");
                if (el) {
                  return el.src;
                }
              }
            }

            return placeholderSrc;
          }
        );

        this.lightbox.on("change", () => {
          window.pauseAllMedia(this);

          // Pause ALL YouTube videos in lightbox by removing iframes
          const pswpContainer = document.querySelector(".pswp");
          if (pswpContainer) {
            // Find all video-elements in all slides
            const allVideoElements =
              pswpContainer.querySelectorAll("video-element");
            const currentSlideIndex = this.lightbox.pswp.currIndex;

            allVideoElements.forEach((videoElement, index) => {
              // Find which slide this video belongs to
              const parentSlide = videoElement.closest(".pswp__item");
              const isCurrentSlide =
                parentSlide &&
                parentSlide.getAttribute("aria-hidden") === "false";

              if (!isCurrentSlide) {
                // Not current slide - remove iframe
                const iframe = videoElement.querySelector("iframe");
                if (iframe && !videoElement.dataset.pswpIframeSrc) {
                  videoElement.dataset.pswpIframeSrc = iframe.src;
                  videoElement.dataset.pswpIframeId = iframe.id || "";
                  videoElement.dataset.pswpIframeAllow = iframe.allow || "";
                  iframe.remove();
                  videoElement.removeAttribute("loaded");
                }
              } else if (isCurrentSlide && videoElement.dataset.pswpIframeSrc) {
                // Current slide - restore iframe if needed
                const newIframe = document.createElement("iframe");
                newIframe.src = videoElement.dataset.pswpIframeSrc;
                if (videoElement.dataset.pswpIframeId) {
                  newIframe.id = videoElement.dataset.pswpIframeId;
                }
                if (videoElement.dataset.pswpIframeAllow) {
                  newIframe.allow = videoElement.dataset.pswpIframeAllow;
                }
                newIframe.setAttribute("allowfullscreen", "");

                // Remove restrictive touch-action to allow YouTube controls on mobile
                videoElement.style.touchAction = "auto";

                const posterButton = videoElement.querySelector(
                  '[id^="DeferredPoster-"]'
                );
                if (posterButton) {
                  videoElement.insertBefore(newIframe, posterButton);
                  posterButton.style.display = "none";
                } else {
                  videoElement.appendChild(newIframe);
                }

                videoElement.setAttribute("loaded", "");

                // Set playing attribute if autoplay is enabled (delayed to prevent errors)
                if (videoElement.hasAttribute("autoplay")) {
                  setTimeout(() => {
                    videoElement.setAttribute("playing", "");
                  }, 200);
                }

                delete videoElement.dataset.pswpIframeSrc;
                delete videoElement.dataset.pswpIframeId;
                delete videoElement.dataset.pswpIframeAllow;
              }

              // Ensure all current video elements have proper touch-action
              if (isCurrentSlide) {
                const currentIframe = videoElement.querySelector("iframe");
                if (currentIframe) {
                  videoElement.style.touchAction = "auto";
                }
              }
            });

            // Ensure navigation buttons are always clickable
            const navButtons = pswpContainer.querySelectorAll(
              ".pswp__button--prev, .pswp__button--next"
            );
            navButtons.forEach((btn) => {
              btn.style.zIndex = "10000";
              btn.style.pointerEvents = "auto";
            });
          }

          if (this.sliderInstance && this.sliderInstance.slider) {
            const { currIndex } = this.lightbox.pswp;
            if (this.sliderInstance.slider.realIndex !== currIndex) {
              this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
            }
          }
        });

        this.lightbox.on("pointerDown", (e) => {
          // Allow touch swipe on all slides including video
          // e.preventDefault() removed to enable swipe navigation
        });

        this.lightbox.on("uiRegister", () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: "next",
              ariaLabel: "Next slide",
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: "prev",
              ariaLabel: "Previous slide",
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: "close-zoom",
            ariaLabel: "Close zoom image",
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: ".js-photoswipe--zoom",
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === "image") {
              const index = Number(media.dataset.mediaIndex) || 0;
              //               console.log("🔍 Opening zoom at index:", index);
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on("afterInit", (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType =
              slides[activeIndex].dataset.mediaType === "model";
            this.toggleSliderDraggableState(!isModelMediaType);

            // Hide poster button on active video slide
            const videoElement =
              slides[activeIndex].querySelector("video-element");
            if (videoElement) {
              // Mark as loaded if iframe already exists
              const iframe = videoElement.querySelector("iframe");
              if (iframe && !videoElement.hasAttribute("loaded")) {
                videoElement.setAttribute("loaded", "");
              }

              const posterButton = videoElement.querySelector(
                '[id^="DeferredPoster-"]'
              );
              if (posterButton) {
                posterButton.style.display = "none";
              }

              // Set playing attribute if autoplay is enabled (delayed to prevent errors)
              if (videoElement.hasAttribute("autoplay")) {
                setTimeout(() => {
                  videoElement.setAttribute("playing", "");
                }, 200);
              }
            }

            // Disable touch swipe on video slides for mobile
            const isVideoSlide =
              slides[activeIndex].dataset.mediaType === "external_video" ||
              slides[activeIndex].dataset.mediaType === "video";
            if (isVideoSlide && window.innerWidth < 1024) {
              this.sliderInstance.slider.allowTouchMove = false;
            } else if (!isModelMediaType) {
              this.sliderInstance.slider.allowTouchMove = true;
            }
          }

          // Setup mobile touch handling
          this.enableMobileTouchOnVideos();
        });
      }

      handleSlideChange() {
        const self = this;

        // Add click listeners to navigation buttons
        const nextButton = this.querySelector(".swiper-button-next");
        const prevButton = this.querySelector(".swiper-button-prev");

        if (nextButton) {
          nextButton.addEventListener(
            "click",
            function () {
              console.log("NEXT BUTTON CLICKED - PAUSING");
              self.pauseAllVideosInGallery();
            },
            true
          ); // Use capture phase
        }

        if (prevButton) {
          prevButton.addEventListener(
            "click",
            function () {
              console.log("PREV BUTTON CLICKED - PAUSING");
              self.pauseAllVideosInGallery();
            },
            true
          ); // Use capture phase
        }

        // Add touch/drag listeners
        this.sliderInstance.slider.on("touchStart", function () {
          console.log("TOUCH START - PAUSING");
          self.pauseAllVideosInGallery();
        });

        this.sliderInstance.slider.on(
          "slideChangeTransitionStart",
          function () {
            console.log("TRANSITION START - PAUSING");
            self.pauseAllVideosInGallery();
          }
        );

        this.sliderInstance.slider.on("realIndexChange", (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            // Restore video iframe if it was removed
            const videoElement =
              slides[activeIndex].querySelector("video-element");
            if (
              videoElement &&
              !videoElement.hasAttribute("loaded") &&
              videoElement.dataset.iframeSrc
            ) {
              // Recreate iframe from stored data
              const newIframe = document.createElement("iframe");
              newIframe.src = videoElement.dataset.iframeSrc;
              if (videoElement.dataset.iframeId) {
                newIframe.id = videoElement.dataset.iframeId;
              }
              if (videoElement.dataset.iframeAllow) {
                newIframe.allow = videoElement.dataset.iframeAllow;
              }
              newIframe.allowFullscreen = true;

              // Add iframe before poster button
              const posterButton = videoElement.querySelector(
                '[id^="DeferredPoster-"]'
              );
              if (posterButton) {
                videoElement.insertBefore(newIframe, posterButton);
                // Hide poster button
                posterButton.style.display = "none";
              } else {
                videoElement.appendChild(newIframe);
              }

              // Mark as loaded
              videoElement.setAttribute("loaded", "");

              // Set playing attribute if autoplay is enabled (delayed to prevent errors)
              if (videoElement.hasAttribute("autoplay")) {
                setTimeout(() => {
                  videoElement.setAttribute("playing", "");
                }, 200);
              }

              // Clear stored data
              delete videoElement.dataset.iframeSrc;
              delete videoElement.dataset.iframeId;
              delete videoElement.dataset.iframeAllow;
            }

            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType =
              slides[activeIndex].dataset.mediaType === "model";
            this.toggleSliderDraggableState(!isModelMediaType);

            // Disable touch swipe on video slides for mobile
            const isVideoSlide =
              slides[activeIndex].dataset.mediaType === "external_video" ||
              slides[activeIndex].dataset.mediaType === "video";
            if (isVideoSlide && window.innerWidth < 1024) {
              this.sliderInstance.slider.allowTouchMove = false;
            } else if (!isModelMediaType) {
              this.sliderInstance.slider.allowTouchMove = true;
            }
          }
        });
      }

      pauseAllVideosInGallery() {
        // Store iframe data and remove from inactive slides

        this.querySelectorAll(
          ".product__media-item:not(.swiper-slide-active)"
        ).forEach((slide) => {
          const videoElement = slide.querySelector("video-element");
          if (videoElement) {
            const iframe = videoElement.querySelector("iframe");
            if (iframe) {
              // Store iframe details before removing
              videoElement.dataset.iframeSrc = iframe.src;
              videoElement.dataset.iframeId = iframe.id || "";
              videoElement.dataset.iframeAllow = iframe.allow || "";

              // Remove iframe to stop playback
              iframe.remove();
            }

            // Mark as needs reload
            videoElement.removeAttribute("loaded");
            videoElement.removeAttribute("playing");

            // Pause native videos
            const video = videoElement.querySelector("video");
            if (video && !video.paused) {
              video.pause();
            }
          }
        });

        // Remove playing from all video-elements
        this.querySelectorAll("video-element[playing]").forEach((el) => {
          el.removeAttribute("playing");
        });

        // Global pauseAllMedia
        if (window.pauseAllMedia) {
          window.pauseAllMedia();
        }
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      enableMobileTouchOnVideos() {
        // Setup video elements for mobile interaction
        const isMobile = window.innerWidth < 1024;
        if (!isMobile) return;

        const videoSlides = this.querySelectorAll(
          '[data-media-type="video"], [data-media-type="external_video"]'
        );
        videoSlides.forEach((slide) => {
          const video = slide.querySelector("video");
          const videoElement = slide.querySelector("video-element");

          if (video) {
            // Allow MP4 video controls
            video.style.pointerEvents = "auto";
          }

          if (videoElement) {
            // Find iframe inside video-element (YouTube/Vimeo)
            const iframe = videoElement.querySelector("iframe");
            if (iframe) {
              // Mark as loaded if iframe exists
              if (!videoElement.hasAttribute("loaded")) {
                videoElement.setAttribute("loaded", "");
              }
            }

            // Set playing attribute if autoplay is enabled (delayed to prevent errors)
            if (
              videoElement.hasAttribute("autoplay") &&
              slide.classList.contains("swiper-slide-active")
            ) {
              setTimeout(() => {
                videoElement.setAttribute("playing", "");
              }, 200);
            }

            // Allow all touch interactions including YouTube controls
            videoElement.style.touchAction = "auto";
          }
        });
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector("product-model");
        if (deferredMedia) deferredMedia.loadContent(false);

        // Hide poster button for video slides to allow YouTube controls
        const videoElement = selected.querySelector("video-element");
        if (videoElement) {
          const posterButton = videoElement.querySelector(
            '[id^="DeferredPoster-"]'
          );
          if (posterButton) {
            posterButton.style.display = "none";
          }
        }
      }

      setActiveMedia(variant) {
        if (!variant) return;

        //         console.log("🎯 setActiveMedia called with variant:", variant);

        // Always try SKU filtering if variant has SKU
        if (variant.sku) {
          try {
            const filtered = this.filterAndSortMediaBySKU(variant.sku);
            if (filtered && filtered.length > 0) {
              //               console.log("✅ SKU filtering successful, gallery updated");
              return;
            } else {
              //               console.log("⚠️ No SKU matches found, showing all images");
              this.showAllImages();
              return;
            }
          } catch (error) {
            console.error("❌ SKU filtering error:", error);
            this.showAllImages();
            return;
          }
        }

        // Fallback to original behavior if no SKU
        //         console.log("ℹ️ Using default behavior (no SKU available)");
        if (
          !variant.hasOwnProperty("featured_media") ||
          !variant.featured_media
        )
          return;

        if (this.sliderInstance && this.sliderInstance.slider) {
          const slideIndex = variant.featured_media.position || 0;
          this.sliderInstance.slider.slideToLoop(slideIndex - 1);
        } else {
          this.sortMediaItems(variant);
        }
      }

      showAllImages() {
        //         console.log("👁️ Showing all images (resetting filter)");

        if (
          !this.originalMediaItems ||
          !this.sliderInstance ||
          !this.sliderInstance.slider
        )
          return;

        // Restore all original images (except swatches)
        const nonSwatchItems = this.originalMediaItems.filter((item) => {
          const img = item.querySelector("img");
          const alt = img?.alt || "";
          return !alt.toUpperCase().includes("_SWATCH");
        });

        // Remove current items
        const allMediaItems = [
          ...this.elements.mediaList.querySelectorAll(".product__media-item"),
        ];
        allMediaItems.forEach((item) => item.remove());

        // Add back all original non-swatch items
        nonSwatchItems.forEach((item, index) => {
          const clone = item.cloneNode(true);

          // Update data-media-index to match position
          clone.dataset.mediaIndex = index;

          // Update zoom button data-media-index
          const zoomButton = clone.querySelector(".js-photoswipe--zoom");
          if (zoomButton) {
            zoomButton.dataset.mediaIndex = index;
          }

          this.elements.mediaList.appendChild(clone);
        });

        // Recreate thumbnails with all non-swatch items
        if (
          this.thumbsInstance &&
          this.thumbsInstance.slider &&
          this.originalThumbnails
        ) {
          const thumbWrapper =
            this.thumbsInstance.slider.el.querySelector(".swiper-wrapper");

          // Clear thumbnails
          thumbWrapper.innerHTML = "";

          // Rebuild from stored original thumbnails
          this.originalThumbnails.forEach((thumb) => {
            const thumbImg = thumb.querySelector("img");
            const thumbAlt = thumbImg?.alt || "";

            if (!thumbAlt.toUpperCase().includes("_SWATCH")) {
              thumbWrapper.appendChild(thumb.cloneNode(true));
            }
          });

          // Destroy thumbnails instance
          this.thumbsInstance.slider.destroy(true, true);
          this.thumbsInstance = false;
        }

        // Destroy main slider
        this.sliderInstance.slider.destroy(true, true);
        this.sliderInstance = false;

        setTimeout(() => {
          // Reinit thumbnails first
          if (this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(
              this.elements.thumbnails,
              this.thumbsOptions
            );
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          // Then reinit main slider
          this.sliderInstance = new window.FoxTheme.Carousel(
            this.elements.viewer,
            this.sliderOptions,
            [FoxTheme.Swiper.Thumbs]
          );
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();

          // Reinitialize image zoom with all images
          if (this.enableImageZoom && this.lightbox) {
            this.lightbox.destroy();
            this.initImageZoom();
          }

          //           console.log("✅ Slider recreated with all images");
        }, 100);
      }

      filterAndSortMediaBySKU(sku) {
        if (!sku) {
          console.warn("⚠️ No SKU provided to filterAndSortMediaBySKU");
          return null;
        }

        //         console.log("🎯 Media Gallery: Filtering by SKU:", sku);

        const skuUpper = String(sku).toUpperCase();

        // Use original stored media items instead of current DOM
        let mediaItems = this.originalMediaItems
          ? [...this.originalMediaItems]
          : [...this.querySelectorAll(".product__media-item")];

        //         console.log("📸 Total media items found:", mediaItems.length);
        //         console.log("🔍 Looking for SKU pattern:", skuUpper);

        // Log ALL media alts to debug (images and videos)
        const allAlts = mediaItems.map((m) => {
          const img = m.querySelector("img");
          const videoElement =
            m.querySelector("video-element") || m.querySelector("video");
          const iframe =
            videoElement?.querySelector("iframe") || m.querySelector("iframe");

          return (
            img?.alt ||
            videoElement?.dataset?.alt ||
            videoElement?.getAttribute("alt") ||
            iframe?.title ||
            iframe?.getAttribute("title") ||
            m.dataset.alt ||
            "no alt"
          );
        });
        //         console.log("📋 ALL media alts (images + videos):", allAlts);

        // DEBUG: Log video elements in detail
        const videoItems = mediaItems.filter((m) => {
          const mediaType = m.dataset.mediaType;
          return mediaType === "video" || mediaType === "external_video";
        });
        //         console.log("🎬 Found", videoItems.length, "video items");
        videoItems.forEach((v, idx) => {
          const img = v.querySelector("img");
          const videoElement = v.querySelector("video-element");
          const iframe =
            videoElement?.querySelector("iframe") || v.querySelector("iframe");
          const video = videoElement?.querySelector("video");
          const iframeSrc = iframe?.src || "";

          //           console.log(`  Video ${idx + 1}:`, {
          //             mediaType: v.dataset.mediaType,
          //             hasImg: !!img,
          //             imgAlt: img?.alt || "NO ALT",
          //             hasVideoElement: !!videoElement,
          //             videoElementDataAlt: videoElement?.dataset?.alt,
          //             hasIframe: !!iframe,
          //             iframeTitle:
          //               iframe?.title || iframe?.getAttribute("title") || "NO TITLE",
          //             iframeSrc: iframeSrc.includes("youtube")
          //               ? "YouTube"
          //               : iframeSrc.includes("vimeo")
          //               ? "Vimeo"
          //               : iframeSrc
          //               ? "Other"
          //               : "NO SRC",
          //             hasVideoTag: !!video,
          //           });
        });

        const displayallInAlts = allAlts.filter((a) =>
          a.toLowerCase().includes("displayall")
        );
        //         console.log(
        //           "📋 Searching for 'displayall' in alts...",
        //           displayallInAlts
        //         );
        //         console.log(
        //           "📋 Total media with 'displayall':",
        //           displayallInAlts.length
        //         );

        // Check for displayall media (images and videos)
        const displayAllMedia = mediaItems.filter((m) => {
          const img = m.querySelector("img");
          const videoElement =
            m.querySelector("video-element") || m.querySelector("video");
          const iframe =
            videoElement?.querySelector("iframe") || m.querySelector("iframe");

          const alt = (
            img?.alt ||
            videoElement?.dataset?.alt ||
            videoElement?.getAttribute("alt") ||
            iframe?.title ||
            iframe?.getAttribute("title") ||
            m.dataset.alt ||
            ""
          ).toUpperCase();

          const src = (
            m.dataset.src ||
            img?.src ||
            iframe?.src ||
            ""
          ).toUpperCase();
          return alt.includes("DISPLAYALL") || src.includes("DISPLAYALL");
        });
        //         console.log("📊 DisplayAll media available:", displayAllMedia.length);
        if (displayAllMedia.length > 0) {
          const displayAllAlts = displayAllMedia
            .map((m) => {
              const img = m.querySelector("img");
              const videoElement =
                m.querySelector("video-element") || m.querySelector("video");
              const iframe =
                videoElement?.querySelector("iframe") ||
                m.querySelector("iframe");
              return (
                img?.alt ||
                videoElement?.dataset?.alt ||
                videoElement?.getAttribute("alt") ||
                iframe?.title ||
                "no alt"
              );
            })
            .slice(0, 10);
          //           console.log("📋 DisplayAll media alts:", displayAllAlts);
        }

        // Helper to test if text matches SKU with common separators, case-insensitive
        const matchesSku = (textUpper, skuUpper) => {
          if (!textUpper) return false;
          return (
            textUpper.includes(`__${skuUpper}_`) ||
            textUpper.includes(`__${skuUpper}-`) ||
            textUpper.endsWith(`__${skuUpper}`) ||
            textUpper.includes(`_${skuUpper}_`) ||
            textUpper.includes(`-${skuUpper}-`) ||
            textUpper.includes(`_${skuUpper}-`) ||
            textUpper.includes(`-${skuUpper}_`) ||
            textUpper.includes(`${skuUpper}_`) ||
            textUpper.includes(`${skuUpper}-`)
          );
        };

        // Filter media items by SKU in alt_text or src, excluding swatch images
        // Also include images/videos with "displayall_" which should show for all SKUs
        // Support video types: youtube, vimeo, mp4video
        const filteredMedia = mediaItems.filter((media) => {
          // Check for image alt text
          const img = media.querySelector("img");
          const imgAlt = img?.alt || "";
          const imgSrc = img?.src || "";

          // Check for video elements (video-element wrapper or native video)
          const videoElement =
            media.querySelector("video-element") ||
            media.querySelector("video");
          const videoAlt =
            videoElement?.dataset?.alt ||
            videoElement?.getAttribute("alt") ||
            "";

          // Check iframe for YouTube/Vimeo (external videos)
          // First try to find iframe inside video-element, then try direct iframe
          const iframe =
            videoElement?.querySelector("iframe") ||
            media.querySelector("iframe");
          const iframeTitle =
            iframe?.title || iframe?.getAttribute("title") || "";
          const iframeSrc = iframe?.src || "";

          // Combine all possible alt text sources
          const mediaAlt =
            imgAlt || videoAlt || iframeTitle || media.dataset.alt || "";
          const mediaSrc = media.dataset.src || imgSrc || iframeSrc || "";
          const mediaAltUpper = mediaAlt.toUpperCase();
          const mediaSrcUpper = mediaSrc.toUpperCase();

          const containsSku =
            matchesSku(mediaAltUpper, skuUpper) ||
            matchesSku(mediaSrcUpper, skuUpper);
          const isDisplayAll =
            mediaAltUpper.includes("DISPLAYALL") ||
            mediaSrcUpper.includes("DISPLAYALL");
          const isSwatch =
            mediaAltUpper.includes("_SWATCH") ||
            mediaSrcUpper.includes("_SWATCH") ||
            mediaAltUpper.includes("SWATCH") ||
            mediaSrcUpper.includes("SWATCH");

          const matches = (containsSku || isDisplayAll) && !isSwatch;

          if (containsSku && isSwatch) {
            //             console.log("  ⊗ Swatch excluded:", mediaAlt || mediaSrc);
          } else if (isDisplayAll && !isSwatch) {
            //             console.log("  ✓ DisplayAll match:", mediaAlt || mediaSrc);
          } else if (matches) {
            //             console.log("  ✓ SKU match:", mediaAlt || mediaSrc);
          }

          return matches;
        });

        //         console.log(
        //           "✨ Filtered to",
        //           filteredMedia.length,
        //           "media items (images/videos)"
        //         );

        if (filteredMedia.length === 0) {
          //           console.log("⚠️ No images found for SKU:", sku);
          return null;
        }

        // Helper function to get alt text from any media type (image, video, iframe)
        const getMediaAlt = (media) => {
          const img = media.querySelector("img");
          const videoElement =
            media.querySelector("video-element") ||
            media.querySelector("video");
          const iframe =
            videoElement?.querySelector("iframe") ||
            media.querySelector("iframe");

          return (
            img?.alt ||
            videoElement?.dataset?.alt ||
            videoElement?.getAttribute("alt") ||
            iframe?.title ||
            iframe?.getAttribute("title") ||
            media.dataset.alt ||
            ""
          ).toUpperCase();
        };

        // Sort filtered media: _main first, then all media sorted by number (displayall and SKU-specific mixed)
        filteredMedia.sort((a, b) => {
          const altA = getMediaAlt(a);
          const altB = getMediaAlt(b);
          const videoElementA = a.querySelector("video-element");
          const videoElementB = b.querySelector("video-element");
          const iframeA =
            videoElementA?.querySelector("iframe") || a.querySelector("iframe");
          const iframeB =
            videoElementB?.querySelector("iframe") || b.querySelector("iframe");
          const srcA = (
            a.dataset.src ||
            a.querySelector("img")?.src ||
            iframeA?.src ||
            ""
          ).toUpperCase();
          const srcB = (
            b.dataset.src ||
            b.querySelector("img")?.src ||
            iframeB?.src ||
            ""
          ).toUpperCase();

          const aIsMain = altA.includes("_MAIN") || srcA.includes("_MAIN");
          const bIsMain = altB.includes("_MAIN") || srcB.includes("_MAIN");

          // Main images always come first
          if (aIsMain && !bIsMain) return -1;
          if (!aIsMain && bIsMain) return 1;

          // After main, sort all media purely by number (displayall and SKU-specific together)

          // Extract numbers for sorting (handles images and videos)
          const extractNumber = (alt, src) => {
            // Clean "LOAD VIDEO: " prefix from video alt texts
            const cleanAlt = alt.replace(/^LOAD VIDEO:\s*/i, "");
            const cleanSrc = src.replace(/^LOAD VIDEO:\s*/i, "");

            // Try to extract from DISPLAYALL pattern (displayall_youtube_003, displayall_002, etc.)
            let match =
              cleanAlt.match(
                /DISPLAYALL[_-]?(?:YOUTUBE|VIMEO|MP4VIDEO)?[_-]?(\d+)/
              ) ||
              cleanSrc.match(
                /DISPLAYALL[_-]?(?:YOUTUBE|VIMEO|MP4VIDEO)?[_-]?(\d+)/
              );
            if (match) return parseInt(match[1], 10);

            // Try to extract from video patterns (SKU_youtube_004, SKU_vimeo_005, SKU_mp4video_003)
            match =
              cleanAlt.match(/(?:YOUTUBE|VIMEO|MP4VIDEO)[_-](\d+)/) ||
              cleanSrc.match(/(?:YOUTUBE|VIMEO|MP4VIDEO)[_-](\d+)/);
            if (match) return parseInt(match[1], 10);

            // Try to extract from _EXTRA_ pattern
            match =
              cleanAlt.match(/_EXTRA_(\d+)/) || cleanSrc.match(/_EXTRA_(\d+)/);
            if (match) return parseInt(match[1], 10);

            // Try to extract from _\d+ pattern (e.g., _001, _002)
            match = cleanAlt.match(/_(\d+)/) || cleanSrc.match(/_(\d+)/);
            if (match) return parseInt(match[1], 10);

            return 999999;
          };

          const numA = extractNumber(altA, srcA);
          const numB = extractNumber(altB, srcB);

          return numA - numB;
        });

        // Update the gallery with filtered and sorted media
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.updateSliderWithFilteredMedia(filteredMedia);
        } else {
          this.updateGridWithFilteredMedia(filteredMedia);
        }

        return filteredMedia;
      }

      updateSliderWithFilteredMedia(filteredMedia) {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        const slider = this.sliderInstance.slider;
        //         console.log(
        //           "🔄 Updating slider with",
        //           filteredMedia.length,
        //           "filtered images"
        //         );

        // Destroy and recreate slider with only filtered images
        const visibleMediaIds = new Set(
          filteredMedia.map((media) => media.dataset.mediaId)
        );

        // Get all media items in the wrapper
        const allMediaItems = [
          ...this.elements.mediaList.querySelectorAll(".product__media-item"),
        ];

        // Remove all items from wrapper
        allMediaItems.forEach((item) => {
          item.remove();
        });

        // Add back clones of filtered items in sorted order (preserve originals)
        filteredMedia.forEach((media, index) => {
          const clone = media.cloneNode(true);

          // Update data-media-index to match filtered position
          clone.dataset.mediaIndex = index;

          // Update zoom button data-media-index
          const zoomButton = clone.querySelector(".js-photoswipe--zoom");
          if (zoomButton) {
            zoomButton.dataset.mediaIndex = index;
          }

          this.elements.mediaList.appendChild(clone);
        });

        // Recreate thumbnails with only filtered items
        if (
          this.thumbsInstance &&
          this.thumbsInstance.slider &&
          this.originalThumbnails
        ) {
          const thumbWrapper =
            this.thumbsInstance.slider.el.querySelector(".swiper-wrapper");

          // Store matching thumbnails from originals
          const matchingThumbs = [];
          filteredMedia.forEach((media) => {
            const mediaId = media.dataset.mediaId;
            const thumb = this.originalThumbnails.find(
              (t) => t.dataset.target === mediaId
            );
            if (thumb) {
              const thumbImg = thumb.querySelector("img");
              const thumbAlt = thumbImg?.alt || "";
              if (!thumbAlt.toUpperCase().includes("_SWATCH")) {
                matchingThumbs.push(thumb.cloneNode(true));
              }
            }
          });

          // Clear and rebuild thumbnails
          thumbWrapper.innerHTML = "";
          matchingThumbs.forEach((thumb) => {
            thumbWrapper.appendChild(thumb);
          });

          // Destroy thumbnails instance
          this.thumbsInstance.slider.destroy(true, true);
          this.thumbsInstance = false;
        }

        // Destroy main slider
        slider.destroy(true, true);
        this.sliderInstance = false;

        // Reinitialize both sliders
        setTimeout(() => {
          // Reinit thumbnails first
          if (this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(
              this.elements.thumbnails,
              this.thumbsOptions
            );
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          // Then reinit main slider
          this.sliderInstance = new window.FoxTheme.Carousel(
            this.elements.viewer,
            this.sliderOptions,
            [FoxTheme.Swiper.Thumbs]
          );
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();

          // Reinitialize image zoom with filtered images
          if (this.enableImageZoom && this.lightbox) {
            this.lightbox.destroy();
            this.initImageZoom();
          }

          //           console.log("✅ Slider recreated with filtered images");
        }, 100);
      }

      updateGridWithFilteredMedia(filteredMedia) {
        if (!this.elements.mediaList) return;

        const allMedia = [...this.querySelectorAll(".product__media-item")];

        allMedia.forEach((media) => {
          media.style.display = "none";
        });

        this.elements.mediaList.innerHTML = "";
        filteredMedia.forEach((media) => {
          media.style.display = "";
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile && this.context !== "quickview") {
          const firstMedia = filteredMedia[0];
          if (firstMedia) {
            window.scrollTo({ top: firstMedia.offsetTop, behavior: "smooth" });
          }
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = "";
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile && this.context !== "quickview") {
          const selectedMedia = this.querySelector(
            `[data-media-id="${variant.featured_media.id}"]`
          );
          if (selectedMedia) {
            window.scrollTo({
              top: selectedMedia.offsetTop,
              behavior: "smooth",
            });
          }
        }
      }
    }
  );
}
